import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, withDefaults } from '../../../../../adapter-vue';
import { IHighlightContent } from '../../../type';
interface IProps {
  contentText: Array<IHighlightContent>;
  messageContent: Record<string, unknown> | undefined;
  displayType: 'bubble' | 'info';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'message-abstract-file',
  props: {
    contentText: { default: () => ([]) as Array<IHighlightContent> },
    messageContent: { default: () => ({}) as Record<string, unknown> },
    displayType: { default: 'bubble' }
  },
  setup(__props: any) {

const props = __props as { contentText: Array<IHighlightContent>, messageContent: Record<string, unknown> | undefined, displayType: 'bubble' | 'info' }



const contentText = ref<Array<{ text: string; isHighlight: boolean }>>(props.contentText);
const typeIcon = computed(() => {
  const fileUrl = props?.messageContent?.url as string;
  const index = fileUrl?.lastIndexOf('.');
  const type = fileUrl?.substring(index + 1);
  return handleFileIconForShow(type);
});
const fileSize = computed(() => props?.messageContent?.size);
const handleFileIconForShow = (type: string) => {
  const urlBase = 'https://web.sdk.qcloud.com/component/TUIKit/assets/file-';
  const fileTypes = [
    'image',
    'pdf',
    'text',
    'ppt',
    'presentation',
    'sheet',
    'zip',
    'word',
    'video',
    'unknown',
  ];
  let url = '';
  let iconType = '';
  fileTypes?.forEach((typeName: string) => {
    if (type?.includes(typeName)) {
      url = urlBase + typeName + '.svg';
      iconType = typeName;
    }
  });
  return {
    iconSrc: url ? url : urlBase + 'unknown.svg',
    iconType: iconType ? iconType : 'unknown',
  };
};

return { __sfc: true,props, contentText, typeIcon, fileSize, handleFileIconForShow }
}

})